module.exports = __webpack_public_path__ + "img/garlands.85590a8d.png";